import { Paper, Stack, Typography } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { useContext } from 'react';
import StarsIcon from '@mui/icons-material/Stars';
import { useTranslation } from 'react-i18next';
import { AuthContext, JURISTILIITTO_CONNECTION_ID } from '../Auth/AuthProvider';
import NoAccessViewActionRow from './NoAccessViewActionRow';

export default function NoAccessView() {
  const { t } = useTranslation();
  const { actions } = useContext(AuthContext);

  const handleLoginJuristiliitto = () => {
    if (actions?.login) {
      actions.login(JURISTILIITTO_CONNECTION_ID);
    } else {
      console.info('Actions not yet loaded');
    }
  };

  return (
    <Paper
      component={Stack}
      elevation={4}
      direction={{ xs: 'column', sm: 'row' }}
      sx={{
        paddingX: { xs: 2 },
        paddingY: { xs: 1.5 },
        alignItems: { xs: 'center', sm: 'flex-start' },
      }}
      gap={2}
    >
      <StarsIcon fontSize='medium' color='primary' />
      <Stack
        direction='column'
        gap={{ xs: 3, sm: 1 }}
        sx={{ alignItems: { xs: 'center', sm: 'flex-start' } }}
      >
        <Typography
          variant='subtitle2'
          sx={{ textAlign: { xs: 'center', sm: 'left' } }}
        >
          {t('noAccessView.onlyAvailableForSubscribers')}
        </Typography>
        <Stack direction='column' gap={{ xs: 3, sm: 1 }}>
          <NoAccessViewActionRow
            prefix={t('noAccessView.alreadySubscribedQuestion')}
            buttonLabel={t('noAccessView.loginRegular')}
            buttonProps={{
              endIcon: <LoginIcon fontSize='inherit' />,
              onClick: () => actions?.login(),
            }}
          />
          <NoAccessViewActionRow
            prefix={t('noAccessView.juristiliittoMemberQuestion')}
            buttonLabel={t('noAccessView.loginJuristiliitto')}
            buttonProps={{
              endIcon: <LoginIcon fontSize='inherit' />,
              onClick: handleLoginJuristiliitto,
            }}
          />
          <NoAccessViewActionRow
            prefix={t('noAccessView.notSubscribedQuestion')}
            buttonLabel={t('noAccessView.tryForFree')}
            buttonProps={{
              // Do not change the ID! It is used in GTM & Google Analytics to track clicks on this link.
              id: 'JA_restricted_content_notification_free_trial_link',
              href: 'https://www.almainsights.fi/juridiikan-palvelut/juridiikan-ajankohtaiset-koekaytto/',
            }}
          />
        </Stack>
      </Stack>
    </Paper>
  );
}
